import React, { useEffect, useState } from 'react'
import { DataGrid } from '@mui/x-data-grid';
import { Box, Typography } from '@mui/material';
import { getUserDataApi } from '../views/dashboard/api';

const  Table = ({ columns, data }) => {

  return (
    <Box sx={{ height: 400, width: '100%', padding: 2 }}>
      <Typography variant="h5" gutterBottom>
      </Typography>
      <DataGrid
        rows={data}
        columns={columns}
        pageSize={5}
        rowsPerPageOptions={[5]}
        disableSelectionOnClick
        sx={{
          '& .MuiDataGrid-cell:hover': {
            color: 'primary.main',
          },
        }}
      />
    </Box>
  );
};

export default Table;
